var hero_testimonials = new Splide( '#hero-testimonials', {
    arrowPath: 'M11 39L30 20L11 0.999998',
    destroy: false,
    // type   : 'loop',
    perPage: 1,
    // padding: { left: 30, right: 30 },
    // gap: '40px',
    autoHeight: true,
    arrows: true, 
    pagination: true,
    breakpoints: {
    867: {
      destroy: false,
      perPage: 1,
      autoHeight: true,
      pagination: true,
      arrows: true,
    }
    }
  } ).mount();
  
  
  var greens_we_grow_slider = new Splide( '#greens_we_grow_slider', {
    arrowPath: 'M11 39L30 20L11 0.999998',
    destroy: false,
    // type   : 'fade',
    perPage: 1,
    // padding: { left: 30, right: 30 },
    // gap: '40px',
    autoHeight: true,
    arrows: true,
    pagination: true,
  } ).mount();
  
  var benefits_usage_slider = new Splide( '#benefits_usage_slider', {
    // arrowPath: 'M11 39L30 20L11 0.999998',
    destroy: false,
    type   : 'fade',
    perPage: 1,
    // padding: { left: 30, right: 30 },
    // gap: '40px',
    autoHeight: true,
    arrows: false,
    pagination: true,
  } ).mount();
  
  // VIDEO TESTIMONIALS
  
  //Youtube Api
  var tag = document.createElement('script');
  tag.src = "https://www.youtube.com/iframe_api";
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  
  // make player array
  var players = new Array();
  
  // make players
  function onYouTubePlayerAPIReady() {
  
  
      $('.video').each(function (index) {
        var videoID = $(this).attr('id');
            videoNum= $(this).data('num');
            console.log(index);
  
            players[index] = new YT.Player(videoID, {
              height: '390',
              width: '640',
              videoId: videoID,
              playerVars: {rel: 0, showinfo: 0, ecver: 2}
            });
  
      });
  };
  
  //stop all video function
  function stopVideo() {
    $(players).each(function(i) {
       this.pauseVideo();
    });
  };
  
  // play button
  $('.toggle').each(function (index) {
  
      var video = $(this).closest('.video-blockquote--video').find('.video');
          videoID = $(video).attr('id');
          videoSrc = $(this).closest('.video-blockquote--video').find('.video').prop('src') ;
          display = video.css('display');
  
          $(this).on("click", function() {
                var   videoContainer = $(this).closest('.video-blockquote--video').find('.video');
                      videoID = $(this).closest('.video-blockquote--video').find('.video').attr('id');
                      image_thumb = $(this).closest('.video-blockquote--video').find('img');
                      players[index].playVideo();
  
                if ($(videoContainer).css('z-index') == '1' ) {
                  $(videoContainer).css("z-index", "10");
                } else {
                  $(videoContainer).css("z-index", "1");
                  players[index].stopVideo();
                }
          });
  });
  
  // splider for testimonials
  var video_testimonials = new Splide( '#main-testimonials', {
    arrowPath: 'M11 39L30 20L11 0.999998',
    destroy: false,
    // type   : 'loop',
    perPage: 1,
    // padding: { left: 20, right: 20 },
    gap: '40px',
    autoHeight: true,
    breakpoints: {
    640: {
      destroy: false,
      autoHeight: true,
    }
    }
  } ).mount();
  
  
  video_testimonials.on( 'moved', function() {
    console.log("Hello world!");
      stopVideo();
      $(".video").css("z-index", "1");
  });
  
  // BENEFITS ACCORDIAN FROM  https://www.w3schools.com/howto/howto_js_accordion.asp
  var acc = document.getElementsByClassName("usage-benefit-card--title");
  var i;
  
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      console.log("clicked");
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
  
  
  // FAQ ACCORDIAN FROM  https://www.w3schools.com/howto/howto_js_accordion.asp
  var acc = document.getElementsByClassName("accordion");
  var i;
  
  for (i = 0; i < acc.length; i++) {
    acc[i].addEventListener("click", function() {
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  }
  /*------------------
   === SMOOTH ANCHOR LINKS SCROLL  ===
   --------------------*/
   $(document).ready(function() {
     // Add smooth scrolling to all links
     $("a").on('click', function(event) {
  
       // Make sure this.hash has a value before overriding default behavior
       if (this.hash !== "") {
  
         // Store hash
         var hash = this.hash;
  
         // Using jQuery's animate() method to add smooth page scroll
         // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
         $('html, body').animate({
           scrollTop: $(hash).offset().top
         }, 1000, function() {
  
           // Add hash (#) to URL when done scrolling (default click behavior)
           window.location.hash = hash;
         });
         return false;
       } // End if
     });
   });